module.exports = __webpack_public_path__ + "img/TRANSITIONS-XTRACTIVE-4.cc9048fb.gif";